import common from './common.json';
import components from './components.json';
import pages from './pages.json';
import errors from './errors.json';

export default {
  common,
  components,
  pages,
  errors,
};